<svg width="16" height="16" viewBox="0 0 16 16" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
        <path d="M4.75317 6.2182C4.96077 6.0106 5.2822 6.01729 5.46969 6.21152L8.06792 8.96373L10.6527 6.21152C10.8402 6.0106 11.175 6.01729 11.3692 6.22489C11.55 6.41237 11.5433 6.72043 11.3491 6.92803L8.71746 9.71373C8.36923 10.0954 7.75317 10.0954 7.40494 9.71373L4.77323 6.92803C4.59917 6.74049 4.58574 6.39232 4.75317 6.2182Z" fill="currentColor"/>
    </g>
</svg>
